
Greenmile.EventNotifications = Greenmile.EventNotifications || {};
Greenmile.EventNotifications.Drivers = Greenmile.EventNotifications.Drivers || {};
Greenmile.EventNotifications.Drivers.TableView = Greenmile.EventNotifications.Drivers.TableView || {};

Greenmile.EventNotifications.Drivers.TableView = (function () {

    function DriversTableView (eventLogDrivers) {
        
        this.getDriversTabContent = function () {

            let content = null;
            const lines = { data: [] };

            const driversKey = [];
            const driversName = [];
            const driversOrganizations = [];

            if (eventLogDrivers) {
                for (let i = 0, length = eventLogDrivers.length; i < length; i++) {
                    driversKey.push(eventLogDrivers[i].driver.key);
                    driversName.push(eventLogDrivers[i].driver.name);
                    driversOrganizations.push(eventLogDrivers[i].driver.organization.description);
                }
            }
            lines.data.push(getDriversKey(driversKey.toString()))
            lines.data.push(getDriversName(driversName.toString()))
            lines.data.push(getDriversOrganizations(driversOrganizations.toString()))
                    
            if (lines.data.length) {
                const grid = new Monet.UI.TableView();
                grid.setLines(lines);
                content = grid.render();
            }
            
            return content;
        };

        const getDriversKey = function (driversKey) {
            return [
                new Monet.UI.TableViewCell('TEXT', Monet.I18n.getResourcesByKey('driver.key')),
                new Monet.UI.TableViewCell('TEXT', driversKey)
            ];
        };

        const getDriversName = function (driversName) {
            return [
                new Monet.UI.TableViewCell('TEXT', Monet.I18n.getResourcesByKey('driver.name')),
                new Monet.UI.TableViewCell('TEXT', driversName)
            ];
        };

        const getDriversOrganizations = function (driversOrganizations) {
            return [
                new Monet.UI.TableViewCell('TEXT', Monet.I18n.getResourcesByKey('driver.organization')),
                new Monet.UI.TableViewCell('TEXT', driversOrganizations)
            ];
        };
    }

    return DriversTableView;

})();

